import { Box } from "@mui/material";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Flex from "../../../../components/Flex";
import ToggleSwitch from "../../../../components/ToggleSwitch";
import { useOutletContext, useParams } from "react-router-dom";
import { UserData } from "../../../../dummy-data/user-data";
import useDisclosure from "../../../../hooks/use-disclosure";
import { ProviderUserType } from "../../../../constants/ProviderUserSchema";
import ActionMenu from "../../../../components/app/ActionMenu";
import SuccessModal, { useSuccess } from "../../../../components/SuccessModal";
import Text from "../../../../components/Text";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_UUID_NAME_LIST,
  DEFAULT_VALUE_LABEL_LIST,
  DGT_Pagination,
  applyDefaultColumnSettings,
  getErrorSnackbar,
  getUnNecessaryTransformData,
  transformMultiSelectFrontEndVal,
} from "../../../../utils/utils";
import { useState } from "react";
import { formatDateTime } from "../../../../utils/date-time-utility";
import { useUpdateProviderUser } from "../../../../queries/use-update-provider-user";
import { useUpdateProviderUserStatus } from "../../../../queries/use-update-provider-status";
import UpsertProviderUserDrawer from "../../../../components/app/admin/provider-groups/ProviderUserDrawer";
import { GENDER_RECORD, STATE_LIST } from "../../../../constants";
import { useProvidersList } from "../../../../queries/provider/setting/use-providers-list";
import ProviderProfileDrawer from "../../../../components/app/ProviderProfileDrawer";
import { GridSortItem } from "@mui/x-data-grid";
import { useProvider } from "../../../../queries/use-provider";
import { useResendLink } from "../../../../queries/use-resend-link";
import { PROVIDER_ROLE_RECORD } from "../../../../constants/master";
import { useSnackbar } from "../../../../hooks/useSnackbar";
import { useArchiveState } from "../../../../hooks/useArchiveState";
import { useArchiveReferralProvider } from "../../../../queries/collaboration/referral/use-referral-provider-archive";
import DeleteModal from "../../../../components/app/DeleteModal";
const ProviderGroupProviders = () => {
  const params = useParams();

  const {
    searchKey,
    groupNpi,
    profileData,
  }: {
    searchKey: string;
    stateFilter: string[];
    groupNpi?: string;
    profileData: any;
  } = useOutletContext();

  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    opened: openedProviderUserModal,
    open: openProviderUserModal,
    close: closeProviderUserModal,
  } = useDisclosure(false);
  const {
    data: ProvidersList,
    isFetching,
    refetch,
    isLoading: tableDataLoading,
  } = useProvidersList({
    gridSorting,
    pagination,
    searchKey,
    xTENANTID: params?.providerGroupId,
    archive: false,
  });
  const [openedResendLink, { open: openResendLink, close: closeResendLink }] =
    useSuccess();
  const { mutateAsync: updateProviderUser } = useUpdateProviderUser();
  const { mutateAsync: resendInvitationLink } = useResendLink();
  const [archive, setArchive] = useState(false);
  const { mutateAsync: archiveProvider } = useArchiveReferralProvider();
  const { deleteDisc, archiveHandler } = useArchiveState(archiveProvider);
  const [providerUUID, setProviderUUID] = useState<string | null>(null);
  const { mutateAsync: providerStatusUpdate } = useUpdateProviderUserStatus();
  const providerUserDisclosure = useDisclosure(false);
  const [selectedProviderUuid, setSelectedProviderUuid] = useState<
    string | null
  >(null);
  const { data } = useProvider({
    providerUuid: providerUUID,
    tenantId: params.providerGroupId,
  });
  const providerData: any = data?.data;

  function editProviderUser(values: ProviderUserType) {
    const transFormData: any = getUnNecessaryTransformData(
      ["licensedStates", "specialities", "workLocations", "acceptedInsurances"],
      values
    );

    return updateProviderUser({
      providerData: transFormData,
      xTENANTID: params?.providerGroupId ?? "0",
    }).then((res) => {
      // setProviderUUID(null);
      return res;
    });
  }

  function toggleStatus<T>(value: boolean, id: T) {
    return providerStatusUpdate({
      providerId: id?.toString() ?? "",
      status: value,
      xTENANTID: params.providerGroupId,
    }).then((res) => {
      refetch();
      return res;
    });
  }

  const showSnackbar = useSnackbar();

  const COLUMNS = applyDefaultColumnSettings<UserData>([
    // {
    //   field: "uuid",
    //   flex: 0.3,
    //   headerName: "Provider ID",
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return <Text>{row?.uuid?.split("-")?.[0]?.toUpperCase()}</Text>;
    //   },
    // },
    {
      // todo change while backend accept sort key
      field: "userInfo",
      flex: 0.7,
      minWidth: 200,
      disableColumnMenu: true,
      headerName: "Name",
      // todo need to fix type
      renderCell: ({ row }: any) => {
        return (
          <Box
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              setSelectedProviderUuid(row.uuid);
              providerUserDisclosure.open();
            }}
          >
            <Flex gap={0.6}>
              <Text
                marginBottom={"3px"}
                color={"primary.main"}
                fontWeight={"medium"}
              >
                {`${row?.firstName} ${row.lastName}`}
              </Text>
              <Text variant="subtitle2">
                {`(${GENDER_RECORD[row?.gender]})`}
              </Text>
            </Flex>
          </Box>
        );
      },
      sortable: false,
    },
    {
      field: "role",
      flex: 0.4,
      minWidth: 130,
      headerName: "Role",
      sortable: false,
      renderCell: ({ row }) => PROVIDER_ROLE_RECORD[row?.role],
    },
    {
      field: "phone",
      flex: 0.5,
      minWidth: 140,
      headerName: "Contact",
      sortable: false,
    },
    {
      field: "email",
      flex: 1,
      minWidth: 240,
      headerName: "Email",
      renderCell: ({ value, row }) => (
        <Flex alignItems={"center"} gap={"4px"}>
          {value ? (
            <>
              <VerifiedIcon
                color={row?.emailVerified ? "success" : "disabled"}
                fontSize="small"
              />
              <Text>{value}</Text>
            </>
          ) : (
            <Text>-</Text>
          )}
        </Flex>
      ),
      sortable: false,
    },
    {
      field: "lastLogin",
      flex: 0.5,
      minWidth: 150,
      headerName: "Last Sign In",
      sortable: false,
      renderCell: ({ ...params }) => {
        return <Text>{params.value ? formatDateTime(params.value) : "-"}</Text>;
      },
    },
    {
      field: "active",
      width: 150,
      headerName: "Status",
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          content={
            (
              <Flex
                flexDirection={"column"}
                gap={1}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Text>You want to change the status ?</Text>
                <Flex flexDirection={"column"} alignItems={"start"}>
                  <Flex>
                    <Text variant="subtitle2">
                      <i>Note:</i>
                    </Text>
                    <Text>
                      <i>
                        {!value
                          ? "Enabling the status will allow the user to sign in to the provider portal"
                          : "Disabling the status will prevent the user from signing in to the provider portal"}
                      </i>
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            ) as any
          }
          id={row.uuid.toString()}
          checked={value}
          onConfirm={(v, id) => toggleStatus(v, id)}
        />
      ),
      sortable: false,
    },
    {
      field: "Action",
      width: 90,
      // todo need to fix type
      renderCell: ({ row }: any) => {
        return (
          <ActionMenu
            options={
              // row.emailVerified
              //   ? actionOptions.filter((option) => option.value !== "resendLink")
              //   : actionOptions
              [
                {
                  value: "resendLink",
                  label: "Resend Link",
                  isDisabled: row?.emailVerified,
                  hoverMsg: "Provider Already Verified",
                },
                { value: "edit", label: "Edit" },
                {
                  value: "archive",
                  label: row?.archive ? "Unarchive" : "Archive",
                  isDisabled: row?.active,
                  hoverMsg: "Make status disable for archive",
                },
              ]
            }
            onActionClick={(v) => {
              if (v === "edit") {
                setProviderUUID(row.uuid);
                openProviderUserModal();
              } else if (v === "archive") {
                setArchive(row?.archive);
                deleteDisc.open(row?.uuid);
              } else {
                resendInvitationLink({
                  linkType: "set",
                  setPasswordRequest: {
                    email: row.email,
                  },
                  xTENANTID: params.providerGroupId,
                })
                  .then(() => {
                    openResendLink();
                  })
                  .catch((err) => {
                    showSnackbar(getErrorSnackbar(err));
                  });
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <Box width={"100%"}>
      <Box height={"calc(100vh - 22rem)"}>
        <CustomDataGridV2
          loading={tableDataLoading || isFetching}
          searchString={searchKey}
          rowCount={ProvidersList?.data?.page?.totalElements}
          getRowId={(row) => row.uuid}
          rows={ProvidersList?.data?.content ?? []}
          columns={COLUMNS}
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
          disableRowSelectionOnClick
        />
      </Box>
      <DeleteModal
        w="380px"
        open={deleteDisc.opened}
        onClose={deleteDisc.close}
        id={deleteDisc.deleteId}
        onConfirmation={(id) =>
          archiveHandler(!archive, id, params?.providerGroupId).then((res) => {
            refetch();
            return res;
          })
        }
        content={`You want to ${
          archive ? "unarchive" : "archive"
        } this Provider User`}
      />
      <SuccessModal
        label="The invitation link has been sent successfully to your email."
        opened={openedResendLink}
        onClose={closeResendLink}
      />
      <ProviderProfileDrawer
        groupNpiNum={groupNpi}
        disClosureHost={providerUserDisclosure}
        providerUuid={selectedProviderUuid}
        profileData={profileData}
      />
      <UpsertProviderUserDrawer
        open={openedProviderUserModal}
        title={"Edit Provider User"}
        shouldGetPrefillList
        prefillSpecialtyList={transformMultiSelectFrontEndVal(
          DEFAULT_UUID_NAME_LIST,
          profileData?.specialities
        )?.map((it) => ({ uuid: it?.uuid, name: it?.name }))}
        onClose={() => {
          closeProviderUserModal();
          setProviderUUID(null);
        }}
        onSubmit={editProviderUser}
        prefillValues={{
          ...(providerData ?? {}),
          providerType: providerData?.providerType ?? undefined,
          groupNpiNumber: groupNpi,
          acceptedInsurances: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            providerData?.acceptedInsurances
          ),
          workLocations: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            providerData?.workLocations
          ),
          ageGroupSeen: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            providerData?.ageGroupSeen
          ),
          careService: transformMultiSelectFrontEndVal(
            DEFAULT_VALUE_LABEL_LIST,
            providerData?.careService
          ),
          licensedStates: transformMultiSelectFrontEndVal(
            STATE_LIST,
            (providerData as any)?.licensedStates
          ),
          spokenLanguages: transformMultiSelectFrontEndVal(
            DEFAULT_UUID_NAME_LIST,
            (providerData as any)?.spokenLanguages
          ),
          specialities: transformMultiSelectFrontEndVal(
            DEFAULT_UUID_NAME_LIST,
            (providerData as any)?.specialities
          ),
          phone: providerData?.phone ?? "",
        }}
      />
    </Box>
  );
};

export default ProviderGroupProviders;
